export default {
  items: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "fa fa-dashboard fa-lg",
      attributes: { "data-cy": "dashboard" },
    },
    {
      name: "Total Accounts",
      url: "/total_account",
      icon: "fa fa-dashboard fa-lg",
      attributes: { "data-cy": "total-accounts" },
    },
    {
      name: "Main Account",
      url: "/main_account",
      icon: "fa fa-dashboard fa-lg",
      attributes: { "data-cy": "main-account" },
    },
    {
      name: "Manage Main Account",
      url: "/manage_main_account",
      icon: "fa fa-money fa-lg",
      attributes: { "data-cy": "manage-main-account" },
    },
    {
      name: "Incoming Transactions",
      url: "/incoming_transactions",
      icon: "icon-arrow-down-circle",
      attributes: { "data-cy": "incoming-transactions" },
    },
    {
      name: "Outgoing Transactions",
      url: "/outgoing_transactions",
      icon: "icon-arrow-up-circle",
      attributes: { "data-cy": "outgoing-transactions" },
    },
    {
      name: "History",
      url: "/history",
      icon: "fa fa-history fa-lg",
      attributes: { "data-cy": "history" },
    },
    {
      name: "Merchants",
      url: "/merchant",
      icon: "fa fa-map fa-lg",
      attributes: { "data-cy": "merchants" },
      children: [
        {
          name: "Merchants list",
          url: "/merchants",
          icon: "fa fa-map-marker fa-lg",
          attributes: { "data-cy": "merchants-list" },
        },
        {
          name: "Merchant requests",
          url: "/merchant-requests",
          icon: "fa fa-map-marker fa-lg",
          attributes: { "data-cy": "merchants-requests" },
        },
      ],
    },
  ],
};
